import {SET, DELETED, ADDED, UPDATED} from './actionTypes';
import update from "immutability-helper";

const initialState = [];

export const reducer = (state = initialState, action) => {
  switch (action.type) {

    case SET:
      return action.reports;

    case DELETED:
      return update(state, {
        $unset: [action.report.id]
      });

    case ADDED:
      return {
        ...state,
        [action.report.id]: action.report
      };

    case UPDATED:
      return update(state, {
        [action.report.id]: {
          $set: action.report
        }
      });

    default:
      return state;
  }
};